/* eslint-disable @typescript-eslint/no-explicit-any */
import { CatalogOption } from '../redux/catalog/interfaces/CatalogReducer';
import utils from '../utils';
import { execute } from './execute';
import { CatalogoEstatusResponse } from './interfaces/FormularioService/CargaFormulario';
import { ConsultaDenunciasArgs, ConsultaDenunciasResponse } from './interfaces/FormularioService/ConsultaDenuncias';
import {
  ConsultaDenunciasByParamsArgs,
  ConsultaDenunciasByParamsResponse,
} from './interfaces/FormularioService/ConsultaDenunciasByParams';
import { ConsultaFolioArgs, ConsultaFolioResponse, ICommentario } from './interfaces/FormularioService/ConsultaFolio';
import { CreateFolderArgs } from './interfaces/FormularioService/CreateFolder';
import { DescargaArchivoArgs } from './interfaces/FormularioService/DescatrgaArchivo';
import { GuardarFormularioArgs } from './interfaces/FormularioService/GuardarFormulario';
import {
  UpdateidDenunciaMejoraArgs,
  UpdateidestatusArgs,
  UpdateidestatusDenunciaResponse,
  UpdateidDenunciaMejoraResponse,
} from './interfaces/FormularioService/UpdateidEstatusDenuncia';
import { UploadFileArgs } from './interfaces/FormularioService/UploadFile';
import { UploadFileUrlsArgs } from './interfaces/FormularioService/UploadFileUrls';

const FormularioService = {
  consultaFolioAdmin: ({ dispatch, folio, showLoader = false }: ConsultaFolioArgs) => {
    return execute({
      dispatch,
      method: 'get',
      route: `admin/legacy/denuncias/${folio}`,
      showLoader,
      useAuthToken: true,
      redirectOn401: true,
    }) as Promise<ConsultaFolioResponse>;
  },
  consultaFolio: ({ dispatch, folio, clave = '', showLoader = false }: ConsultaFolioArgs) => {
    return execute({
      dispatch,
      method: 'post',
      route: `user/legacy/denuncias/${folio}`,
      data: {
        clave,
      },
      showLoader,
      showNotificationError: true,
    }) as Promise<ConsultaFolioResponse>;
  },
  updateEstatusDenuncia: ({ dispatch, folio, idEstatusDenuncia, comentarios = '' }: UpdateidestatusArgs) => {
    return execute({
      dispatch,
      method: 'post',
      route: 'admin/legacy/estatus-denuncia',
      useAuthToken: true,
      redirectOn401: true,
      data: {
        folio,
        idEstatusDenuncia,
        comentarios,
      },
    }) as Promise<UpdateidestatusDenunciaResponse>;
  },

  updateIdDenuncia: ({ dispatch, folio, idDenunciaMejora }: UpdateidDenunciaMejoraArgs) => {
    return execute({
      dispatch,
      method: 'post',
      route: 'admin/legacy/estatusDenunciaMejora',
      useAuthToken: true,
      redirectOn401: true,
      data: {
        folio,
        idDenunciaMejora,
      },
    }) as Promise<UpdateidDenunciaMejoraResponse>;
  },

  consultaDenuncias: ({ dispatch, dataFilters }: ConsultaDenunciasArgs) => {
    return execute({
      dispatch,
      method: 'get',
      route: 'admin/legacy/denuncias/report',
      useAuthToken: true,
      redirectOn401: true,
      showLoader: true,
      data: dataFilters,
    }) as Promise<ConsultaDenunciasResponse>;
  },

  consultaDenunciasByParams: ({ dispatch, objParams }: ConsultaDenunciasByParamsArgs) => {
    return execute({
      dispatch,
      method: 'get',
      route: utils.createQueryParams('admin/legacy/denuncias', objParams),
      useAuthToken: true,
      redirectOn401: true,
    }) as Promise<ConsultaDenunciasByParamsResponse>;
  },

  guardarFormulario: ({ dispatch, data, captcha }: GuardarFormularioArgs) => {
    return execute({
      dispatch,
      method: 'post',
      route: 'user/legacy/denuncias',
      data,
      showLoader: true,
      headers: {
        'Content-Type': 'multipart/form-data',
        captcha,
      },
    }) as Promise<{ clave: string; folio: string }>;
  },

  descargaArchivo: ({ dispatch, idFolio }: DescargaArchivoArgs) => {
    return execute({
      dispatch,
      method: 'get',
      route: `formulario/denuncias/archivos/${idFolio}`,
    });
  },

  uploadFile: ({ dispatch, identifier = '', data }: UploadFileArgs) => {
    return execute({
      dispatch,
      method: 'post',
      route: `${process.env.REACT_APP_sharingUrl}/files`,
      params: { async: false, path: `${process.env.REACT_APP_sharingPath}/${identifier}` },
      headers: {
        'Content-Type': 'application/form-data',
        site: process.env.REACT_APP_sharingSite || '',
        Authorization: `Basic ${process.env.REACT_APP_sharingToken}`,
      },
      data,
      showLoader: true,
    }) as Promise<void>;
  },
  createFolder: ({ dispatch, identifier = '' }: CreateFolderArgs) => {
    return execute({
      dispatch,
      method: 'post',
      route: `${process.env.REACT_APP_sharingUrl}/folders`,
      params: { folder: `${identifier}`, path: `${process.env.REACT_APP_sharingPath}` },
      headers: {
        site: process.env.REACT_APP_sharingSite || '',
        Authorization: `Basic ${process.env.REACT_APP_sharingToken}`,
      },
      showLoader: true,
    }) as Promise<void>;
  },
  uploadFileUrls: ({ dispatch, folio = '', clave = '', urls = [] }: UploadFileUrlsArgs) => {
    return execute({
      dispatch,
      method: 'put',
      route: 'formulario/denuncias/archivos',
      data: {
        folio,
        clave,
        listaArchivos: urls,
      },
      showLoader: true,
    }) as Promise<void>;
  },
  getTypeCaptcha: () =>
    execute({
      method: 'get',
      route: 'captcha/servicio',
    }) as Promise<string>,
  catalogStatus: ({ dispatch }: any) => {
    return execute({
      dispatch,
      method: 'get',
      route: 'catalogos/legacy/estatus',
    }) as Promise<CatalogOption[]>;
  },
  responseComment: ({
    dispatch,
    idComentario,
    comentario,
  }: {
    dispatch: any;
    idComentario: string;
    comentario: string;
  }) => {
    return execute({
      dispatch,
      method: 'put',
      route: `user/legacy/comentario/${idComentario}`,
      data: {
        comentario,
      },
      showLoader: true,
      showNotificationError: true,
    }) as Promise<ICommentario>;
  },
  sendAdminComment: ({ dispatch, idDenuncia, comentario }: { dispatch: any; idDenuncia: string; comentario: string }) => {
    return execute({
      dispatch,
      method: 'post',
      route: `admin/legacy/${idDenuncia}/comentario`,
      useAuthToken: true,
      redirectOn401: true,
      data: {
        comentario,
      },
      showLoader: true,
    }) as Promise<ICommentario>;
  },
  downloadAdminFile: ({ dispatch, idArchivo }: { dispatch: any; idArchivo: string }) => {
    return execute({
      dispatch,
      method: 'post',
      route: `admin/legacy/descargar/${idArchivo}`,
      useAuthToken: true,
      redirectOn401: true,
      showLoader: true,
      headers: {
        Accept: 'application/octet-stream',
      }
    });
  }
};

export default FormularioService;
